<template>
  <div>
    <NavbarMain />
    <slot />

    <FooterMobile v-if="!isAuthRoute" />
    <FooterDesktop />
  </div>
</template>

<script setup lang="ts">
const route = useRoute();

const isAuthRoute = computed<boolean>(() =>
  route.path.replace(/^\/(en|ru)(?=\/)/, "").includes("/auth"),
);
</script>
